import { Checkbox } from 'components/forms/Checkbox';

export type AllCategoryCheckboxProps = Readonly<{
    total: number;
    selected: number;
    onSelectAll: () => void;
    onDeselectAll: () => void;
    className?: string;
}>;

export function SelectAllCheckbox({
    total,
    selected,
    onSelectAll,
    onDeselectAll,
    className,
}: AllCategoryCheckboxProps) {
    const allSelected = selected === total;
    const someSelected = selected > 0;
    const isIndeterminate = someSelected && !allSelected;

    return (
        <label
            className={`flex-row cursor-pointer ${className ?? ''}`}
            aria-label="Select All"
        >
            <Checkbox
                checked={allSelected || (isIndeterminate && 'indeterminate')}
                onChange={someSelected ? onDeselectAll : onSelectAll}
            />
            <span className="bold ml-5">Select All</span>
        </label>
    );
}
